import {DeltaEvent, DeltaEventMethodType, UpdateType} from "../../../gd/manager/delta-handler/types";
import createUpdateAction from "../../../gd/manager/delta-handler/session-events-handlers/task/create-update-action";

export function convertExpenseEventToUpdateAction(deltaEvent:DeltaEvent) {

    switch (deltaEvent.method) {
        case DeltaEventMethodType.NEW   :
            return createUpdateAction(UpdateType.EXPENSE_NEW, deltaEvent.data)

        case DeltaEventMethodType.DELETE:
            return createUpdateAction(UpdateType.EXPENSE_DELETE, {id: deltaEvent.header.expense.id})

        case DeltaEventMethodType.DELTA :
            const deltaData = _.assign({}, deltaEvent.data, {id: deltaEvent.header.expense.id})
            return createUpdateAction(UpdateType.EXPENSE_DELTA, deltaData)

    }

}